import './freewish.css';
import React from 'react'
import Cartimage from '../Images/wish.png';
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
const FreeWishlist = () => {
  const { t } = useTranslation();
  return (
    <div className='free-wish d-flex justify-content-center mt-5 '>
      <div className="container">
        <h2>{t("chart")}</h2>
        <div className="content">
          <img src={Cartimage} alt='' />
          <h3>{t("epmcartT1")}</h3>
          <p>{t("epmcartT2")}</p>
          <Link to="/">{t("startShopping")}</Link>
        </div>
      </div>
    </div>
  )
}

export default FreeWishlist